var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64258 11.436C6.64802 11.436 5.69419 11.0409 4.99093 10.3377C4.28767 9.63442 3.89258 8.6806 3.89258 7.68604C3.89258 6.69147 4.28767 5.73765 4.99093 5.03438C5.69419 4.33112 6.64802 3.93604 7.64258 3.93604C8.63714 3.93604 9.59097 4.33112 10.2942 5.03438C10.9975 5.73765 11.3926 6.69147 11.3926 7.68604C11.3926 8.6806 10.9975 9.63442 10.2942 10.3377C9.59097 11.0409 8.63714 11.436 7.64258 11.436ZM7.01758 0.811035H8.26758V2.68604H7.01758V0.811035ZM7.01758 12.686H8.26758V14.561H7.01758V12.686ZM2.33945 3.26666L3.2232 2.38291L4.54883 3.70854L3.66508 4.59229L2.33945 3.26729V3.26666ZM10.7363 11.6635L11.6201 10.7798L12.9457 12.1054L12.062 12.9892L10.7363 11.6635ZM12.062 2.38229L12.9457 3.26666L11.6201 4.59229L10.7363 3.70854L12.062 2.38291V2.38229ZM3.66508 10.7798L4.54883 11.6635L3.2232 12.9892L2.33945 12.1054L3.66508 10.7798ZM14.5176 7.06104V8.31104H12.6426V7.06104H14.5176ZM2.64258 7.06104V8.31104H0.767578V7.06104H2.64258Z",
    fill: "#EAAC0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.142578 0.186035)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.3a0d062c8493b3b955a93702ed19662b.svg";
export { ForwardRef as ReactComponent };